module.exports = __webpack_public_path__ + "img/poster-hotels.4e858b9d.jpg";